export type MortgageInterestRatePeriod =
  /* "variable" |*/
  "5" | "10" | "20" | "30";

export type DebtMarketValue = "nhg" | "60" | "80" | "90" | "100";

export type MortgageInterestRatePeriodOption = {
  value: MortgageInterestRatePeriod;
  label: string;
};

export const mortgageInterestRatePeriodOptions: MortgageInterestRatePeriodOption[] =
  [
    // { value: "variable", label: "Variabel" },
    { value: "5", label: "5" },
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "30", label: "30" },
  ];

export type DebtMarketValueOption = {
  value: DebtMarketValue;
  label: string;
};

export const debtMarketValueOptions: DebtMarketValueOption[] = [
  { value: "nhg", label: "NHG" },
  { value: "60", label: "60%" },
  { value: "80", label: "80%" },
  { value: "90", label: "90%" },
  { value: "100", label: "100%" },
];

export type MortgageInterestRate = {
  id: number;
  image: string;
  /** Bank name (e.g., "ABN AMRO") */
  name: string;
  /**
   * URL-friendly slug for the bank (e.g., "abn-amro").
   * Generated by the backend as the source of truth.
   */
  slug?: string;
  /** Product name (e.g., "ABN AMRO Budget Hypotheek") */
  productName?: string;
  rate: number;
  debtMarketValues?: {
    [key in DebtMarketValue]: number;
  };
};
